import Link from "next/link";

const PageBreadcrumbTitle = ({ pageName }) => {
  return (
    <div className="form-page-header text-center heading3">
      <Link className="header-logo" href="/">
        <img
          src="/static/website-assets/images/custom/logo/play-logo-white.svg"
          alt=""
        />
      </Link>
      <div className="space16"></div>
      <div className="breadcrumbs">
        <div>
          <Link href="/">Home </Link>
        </div>
        <div>
          <i className="fa-solid fa-angle-right"></i>
        </div>
        <div>
          <span>{pageName}</span>
        </div>
      </div>
    </div>
  );
};

export default PageBreadcrumbTitle;
